import { orderBy } from "lodash";
import {
  setAppConfig,
  setGenericDataV2InitStates,
} from "../../actions/generic-data";
import GenericApi from "../../services/generics";
import Config from "../../config";

export const getVipPackages = async ({ page = 0, limit = 25 }) => {
  const response = await GenericApi.getVipRequests({ page, limit });
  return response;
};

export const initializeGenericData = () => async (dispatch) => {
  const nextState = {};

  let response = await GenericApi.getGenericFilters();
  if (!response.success) {
    return;
  }
  const {
    allCountries,
    civilStatuses,
    countries,
    religions,
    ethnicities,
    educationLevels,
    foodPreferences,
    professions,
    visaStatuses,
    stars,
    starSigns,
    motherTongues,
    gothras,
  } = response.body;

  const sortedReligions = orderBy(
    religions ?? [],
    ["sortOrder"],
    ["asc"],
  ).filter((religion) => religion.id !== "other");
  const sortedEthnicities = orderBy(
    ethnicities ?? [],
    ["sortOrder"],
    ["asc"],
  ).filter((ethnicity) => ethnicity.id !== "other");
  const sortedMaritalStatuses = orderBy(civilStatuses ?? ["sortOrder"], [
    "asc",
  ]).filter((status) => status.id !== "other");
  const sortedResidentCountries = orderBy(countries ?? [], ["code"], ["asc"]);
  const sortedAllCountries = orderBy(allCountries ?? [], ["code"]);
  const sortedEducationLevels = orderBy(
    educationLevels ?? [],
    ["sortOrder"],
    ["asc"],
  );
  const sortedFoodPreferences = orderBy(
    foodPreferences ?? [],
    ["sortOrder"],
    "asc",
  );
  const sortedProfessions = orderBy(professions ?? [], ["sortOrder"], ["asc"]);
  const sortedVisaStatus = orderBy(visaStatuses ?? [], ["sortOrder"], ["asc"]);

  const genericFilters = {
    religions: sortedReligions,
    ethnicities: sortedEthnicities,
    maritalStatuses: sortedMaritalStatuses,
    residentCountries: sortedResidentCountries,
    allCountries: sortedAllCountries,
    educationLevels: sortedEducationLevels,
    foodPreferences: sortedFoodPreferences,
    professions: sortedProfessions,
    visaStatuses: sortedVisaStatus,
    stars: stars ?? [],
    starSigns: starSigns ?? [],
    motherTongues: motherTongues ?? [],
    gothras: gothras ?? [],
  };

  response = await GenericApi.getPricingPackages({ showNew: false });
  if (!response.success || !Array.isArray(response.body)) {
    return;
  }

  const oldPackages = response.body.map((current) => ({
    ...current,
    oldPackage: true,
  }));

  response = await GenericApi.getPricingPackages({ showNew: true });
  if (!response.success || !Array.isArray(response.body)) {
    return;
  }

  nextState.pricingPackages = [...oldPackages, ...response.body];
  nextState.initialized = true;
  nextState.genericFilters = genericFilters;
  dispatch(setGenericDataV2InitStates(nextState));
};

export const initializeConfig = () => async (dispatch) => {
  const responce = await GenericApi.getAppConfig();
  if (responce.success) {
    dispatch(setAppConfig(responce.body));
  }
};
